import { AutoComplete, AutoCompleteProps, Button, DatePicker } from "antd";
import { api } from "../../../config";
import { AuthenticationState, UserInterface } from "../../../interfaces/users";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { addHours } from "date-fns";
import { useQuery } from "react-query";
import { set } from "lodash";

export type Event = {
  id?: number;
  start_time?: Date | null;
  end_time?: Date | null;
  assembler_id?: number | null;
  seniority_id?: number;
  description?: string
};

interface RescheduleAssemblyEventProps {
  event: Event;
  onSuccess?: (event: any) => void;
  onCancel?: () => void;
}

const RescheduleAssemblyEvent = ({
  event,
  onSuccess,
  onCancel,
}: RescheduleAssemblyEventProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { data: assemblers } = useQuery<UserInterface[]>("users-assemble", () =>
    api(token).get(`/users?moduleName=ASSEMBLE_APP&permission=USER`)
  );
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<AutoCompleteProps["options"]>([]);
  console.log("event", event);
  const [newEvent, setNewEvent] = useState<Event>({
    id: event.id,
    start_time: event.start_time,
    end_time: event.end_time,
    assembler_id: event.assembler_id,
    seniority_id: event.seniority_id,
  });

  const [assembler, setAssembler] = useState<UserInterface | undefined>();
  useEffect(() => {
    setAssembler(assemblers?.find((user) => user.id === event.assembler_id));
  }, [assemblers, event.assembler_id]);

  useEffect(() => {
    console.log("assembler", assembler);
  }, [assembler]);

  const getPanelValue = (text: string) => {
    return assemblers
      ?.filter((user) =>
        user.fullName.toLowerCase().includes(text.toLowerCase())
      )
      .map((user) => ({ value: user.fullName, label: user.fullName }));
  };

  const onReschedule = () => {
    try {
      setLoading(true);

      if (!newEvent.start_time || !newEvent.end_time || !newEvent.assembler_id)
        throw new Error("Preencha todos os campos");
console.log("newEvent.seniority_id", newEvent.seniority_id)
      if (!assembler?.seniorityId) throw new Error("Selecione um montador");

      if (newEvent.seniority_id  && (assembler?.seniorityId ?? 0) > (newEvent.seniority_id ?? 0)) {
        toast.error(
          "O montador selecionado possui uma senioridade inferior a do ticket"
        );
        return;
      }

      api(token)
        .put(`events/assemble/${newEvent.id}`, {
          start: newEvent.start_time,
          end: newEvent.end_time,
          assemblerId: newEvent.assembler_id,
        })
        .then(() => {
          onSuccess && onSuccess(newEvent);
          toast.success("Ticket reagendado com sucesso!");
        })
        .catch((error) => {
          console.log(error);
          toast.error("Ocorreu um erro ao reagendar o ticket");
        });
    } catch (error) {
      console.log(error);
      toast.error("Ocorreu um erro ao reagendar o ticket");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-2">
          Novo Horário de Início
          <DatePicker
            showTime
            format="DD/MM/YY HH:mm"
            minuteStep={15}
            allowClear={false}
            disabledDate={(date) => date.isBefore(new Date())}
            disabledTime={() => ({
              disabledHours: () => [0, 1, 2, 3, 4, 5, 22, 23],
            })}
            value={dayjs(newEvent.start_time)}
            onChange={(value) => {
              if (
                value &&
                (value.isAfter(new Date()) || value.isSame(new Date()))
              ) {
                setNewEvent({
                  ...newEvent,
                  start_time: value.toDate(),
                  end_time: addHours(value.toDate(), 6),
                });
              } else {
                if (value) {
                  toast.error("Data inválida");
                }
                setNewEvent({
                  ...newEvent,
                  start_time: null,
                  end_time: null,
                });
              }
            }}
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          Novo Horário Final
          <DatePicker
            showTime
            format="DD/MM/YY HH:mm"
            minuteStep={15}
            allowClear={false}
            disabledDate={(date) => date.isBefore(new Date())}
            disabledTime={() => ({
              disabledHours: () => [0, 1, 2, 3, 4, 5, 22, 23],
            })}
            onChange={(value) => {
              if (
                value &&
                (value.isAfter(new Date()) || value.isSame(new Date()))
              ) {
                setNewEvent({
                  ...newEvent,
                  end_time: value.toDate(),
                });
              } else {
                if (value) {
                  toast.error("Data inválida");
                }
                setNewEvent({
                  ...newEvent,
                  end_time: null,
                });
              }
            }}
            placeholder=""
            value={dayjs(newEvent.end_time)}
          />
        </div>

        {assembler?.fullName && (
          <div className="flex flex-col items-center justify-center gap-2">
            Novo Montador
            <AutoComplete
              options={options}
              style={{ width: 200 }}
              onSelect={(value) => {
                setAssembler(
                  assemblers?.find((user) => user.fullName === value)
                );
                setNewEvent({
                  ...newEvent,
                  assembler_id:
                    assemblers?.find((user) => user.fullName === value)?.id ||
                    null,
                });
              }}
              defaultValue={
                assemblers?.find((user) => user.id === assembler?.id)?.fullName
              }
              onSearch={(text) => setOptions(getPanelValue(text))}
              placeholder="Busque o Montador"
            />
          </div>
        )}
      </div>
      <div className="flex  items-center justify-between gap-4">
        <Button className="mt-4" danger onClick={onCancel} loading={loading}>
          Cancelar
        </Button>
        <Button
          className="mt-4"
          type="primary"
          onClick={() => onReschedule()}
          loading={loading}
        >
          Reagendar
        </Button>
      </div>
    </div>
  );
};

export default RescheduleAssemblyEvent;
